export const enum MessageCommandType {
    WaitingGame = 'WaitingGame',
    InputWidget = 'text_chat_widget',
    GenerateNewOTPReq = 'GenerateNewOTPReq',
    GenerateNewOTPResp = 'GenerateNewOTPResp',
    OTPCodeV2SendCode = 'OTPCodeV2SendCode',
    OTPCodeV2HideWidget = 'OTPCodeV2HideWidget',
    OTPCodeV2FailureCode = 'OTPCodeV2FailureCode',
    MasterDetailRequest = 'masterDetailRequest',
    MasterDetailResponse = 'masterDetailResponse',
    UserPermissionsRequest = 'userPermissionsReq',
    UserPermissionsResponse = 'userPermissionsResp',
    GeoLocationRequest = 'geoLocationReq',
    GeoLocationResponse = 'geoLocationResp',
    UpdateParameters = 'updateParameters',
    SendFingerPrintRequest = 'deviceFingerprintReq',
    SendFingerPrintResponse = 'deviceFingerprintResp',
    SurveyReply = 'surveyReply',
    SurveyRequest = 'surveyRequest',
    PromoBanner = 'promoBanner',
}
